export default __webpack_public_path__ + "static/media/access-error-placeholder.50f1e383.svg";